import { Roles } from "features/panelManagement/accessManagement/types/access";
import {
    NavbarDefinition,
    NavbarDisplayIcon,
    NavbarMenuItem,
} from "../types/navbar";

export const MAIN_NAVBAR: NavbarDefinition = {
    titleText: "neotech admin",
    logoutText: "Logout",
    menuItems: [
        "dashboard",
        "tagEditor",
        "inventoryEditor",
        "articleEditor",
        "panelManagement",
    ],
};

export const MENU_ITEMS: NavbarMenuItem[] = [
    {
        accessor: "dashboard",
        displayText: "Dashboard",
        displayIcon: NavbarDisplayIcon.Dashboard,
        route: "/dashboard/analytics",
    },
    {
        accessor: "dashboard:analytics",
        displayText: "Analytics",
        displayIcon: NavbarDisplayIcon.Analytics,
        route: "/dashboard/analytics",
    },
    {
        accessor: "dashboard:deployments",
        displayText: "Deployments",
        displayIcon: NavbarDisplayIcon.Deployments,
        route: "/dashboard/deployments",
    },
    {
        accessor: "tagEditor",
        displayText: "Tags",
        displayIcon: NavbarDisplayIcon.Tag,
        route: "/tag-editor/category",
    },
    {
        accessor: "tagEditor:category",
        displayText: "Category",
        displayIcon: NavbarDisplayIcon.Category,
        route: "/tag-editor/category",
    },
    {
        accessor: "tagEditor:supplier",
        displayText: "Supplier",
        displayIcon: NavbarDisplayIcon.Supplier,
        route: "/tag-editor/supplier",
    },
    {
        accessor: "tagEditor:application",
        displayText: "Application",
        displayIcon: NavbarDisplayIcon.Tag,
        route: "/tag-editor/application",
    },
    {
        accessor: "tagEditor:process",
        displayText: "Process",
        displayIcon: NavbarDisplayIcon.Process,
        route: "/tag-editor/process",
    },
    {
        accessor: "tagEditor:custom",
        displayText: "Custom",
        displayIcon: NavbarDisplayIcon.Custom,
        route: "/tag-editor/custom",
    },
    {
        accessor: "inventoryEditor",
        displayText: "Inventory",
        displayIcon: NavbarDisplayIcon.Product,
        route: "/inventory-editor",
    },
    {
        accessor: "articleEditor",
        displayText: "Text Content",
        displayIcon: NavbarDisplayIcon.News,
        route: "/article-editor/news",
    },
    {
        accessor: "articleEditor:news",
        displayText: "News",
        displayIcon: NavbarDisplayIcon.News,
        route: "/article-editor/news",
    },
    {
        accessor: "articleEditor:article",
        displayText: "Article",
        displayIcon: NavbarDisplayIcon.Article,
        route: "/article-editor/article",
    },
    {
        accessor: "articleEditor:supplier",
        displayText: "Supplier",
        displayIcon: NavbarDisplayIcon.Supplier,
        route: "/article-editor/supplier",
    },
    {
        accessor: "panelManagement",
        displayText: "Panel Management",
        displayIcon: NavbarDisplayIcon.PanelManagement,
        route: "/panel-management/backups",
        rolesPermitted: [Roles.ADMIN, Roles.OWNER],
    },
    {
        accessor: "panelManagement:backups",
        displayText: "Backups",
        displayIcon: NavbarDisplayIcon.Backups,
        route: "/panel-management/backups",
        rolesPermitted: [Roles.ADMIN, Roles.OWNER],
    },
    {
        accessor: "panelManagement:accessManager",
        displayText: "Access Manager",
        displayIcon: NavbarDisplayIcon.Access,
        route: "/panel-management/manage-access",
        rolesPermitted: [Roles.OWNER],
    },
    {
        accessor: "panelManagement:logs",
        displayText: "Logs",
        displayIcon: NavbarDisplayIcon.Logs,
        route: "/panel-management/logs",
        rolesPermitted: [Roles.OWNER],
    },
];
